import { render, staticRenderFns } from "./AddSermon.vue?vue&type=template&id=42936570&scoped=true&"
import script from "./AddSermon.vue?vue&type=script&lang=js&"
export * from "./AddSermon.vue?vue&type=script&lang=js&"
import style0 from "./AddSermon.vue?vue&type=style&index=0&id=42936570&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42936570",
  null
  
)

export default component.exports